<template>
    <v-container class="pa-3">
        <h1 class="text-h6 pb-3 text-center">
            Job #{{jobId}}
            <v-btn @click="toggleIsEditable" :color="isEditable ? 'error': ''" pr fab depressed x-small>
                <v-icon>{{isEditable ? mdiClose : mdiPencil}}</v-icon>
            </v-btn>
        </h1>
        <v-form @click.prevent="updateJobDetails">
            <v-text-field dense readonly label="customer" v-model="jobDetails.customer" v-bind="toggleEditability"></v-text-field>
            <v-select dense label="entity" v-model="jobDetails.corp_id" :readonly="!isEditable" v-bind="toggleEditability" :items="corps" item-value="corp_id" item-text="corp"></v-select>
            <v-row>
                <v-col><v-text-field dense label="address" v-model="jobDetails.address" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col><v-text-field dense label="apartment" v-model="jobDetails.apartment" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col>
                    <v-select dense label="borough" v-model="jobDetails.borough" :items="options.boroughs" v-bind="toggleEditability"></v-select></v-col>
            </v-row>
            <v-row>
                <v-col><v-text-field dense label="bin number" v-model="jobDetails.bin_number" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col><v-text-field dense label="block" v-model="jobDetails.block" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col><v-text-field dense label="lot" v-model="jobDetails.lot" v-bind="toggleEditability"></v-text-field></v-col>
            </v-row>
            <v-row>
                <v-col><v-text-field dense label="project billing info" v-model="jobDetails.project_billing_information" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col><v-text-field dense label="registration id" v-model="jobDetails.registration_id" v-bind="toggleEditability"></v-text-field></v-col>
            </v-row>
            <v-row>
                <v-col><v-text-field dense label="contact name" v-model="jobDetails.contact_name" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col><v-text-field dense label="contact phone" v-model="jobDetails.contact_phone_number" v-bind="toggleEditability"></v-text-field></v-col>
            </v-row>
            <v-row>
                <v-col><v-select dense label="job type" v-model="jobDetails.service_id" :items="options.services" item-text="service" item-value="service_id" v-bind="toggleEditability"></v-select></v-col>
                <v-col><v-select dense label="scope" v-model="jobDetails.job_size" :items="options.scopes" v-bind="toggleEditability"></v-select></v-col>
            </v-row>
            <v-row>
                <v-col><v-select :readonly="!isEditable" dense label="supervisor" v-model="jobDetails.supervisor_id" :items="options.supervisors" item-text="supervisor" item-value="supervisor_id" v-bind="toggleEditability"></v-select></v-col>
            </v-row>
            <v-row>
                <v-col><v-text-field dense label="price" v-model="jobDetails.price" v-bind="toggleEditability"></v-text-field></v-col>
                <v-col><v-select dense label="status" v-model="jobDetails.stage_id" :items="stages" item-value="stage_id" item-text="stage" v-bind="toggleEditability"></v-select></v-col>
            </v-row>
            <v-text-field disabled v-for="(note,idx) in jobDetails.notes" :key="idx"  :value="note"></v-text-field>
            <v-textarea v-if="isEditable" placeholder="Add a note..." label="note" v-model="newNote"></v-textarea>
        </v-form>
        <div class="text-center mb-3">
            <v-btn v-if="!isEditable" class="mx-1" depressed :to="{name: 'jobs'}">back</v-btn>
            <v-btn v-if="isEditable" class="mx-1" depressed type="submit">cancel</v-btn>
            <v-btn v-if="isEditable" :loading="submitting" :disabled="submitting" class="mx-1" color="primary" depressed @click="updateJobDetails">save</v-btn>
        </div>
    </v-container>
</template>

<script>
import {loadJobDetails, loadEditingOptions, updateJob, singleObjectHeader, postNote, postJobStage} from "../data";
    import {mdiPencil, mdiClose} from '@mdi/js'
import {loadUserId, upsertHeader} from "@/data";

    export default {
        name: "EditJob.vue",
        props: ["jobId"],
        async mounted() {
            // todo: get corps for customer,  all stages
            const {data, error} = await loadJobDetails({job_id: `eq.${this.jobId}`}, {...singleObjectHeader})
            if (!error) {
              this.customer = data.customer
              this.jobDetails = data
              this.originalJobDetails = {...data}
            }
            const { data: options, error: optionsError } = await loadEditingOptions({}, {...singleObjectHeader})
            if (!optionsError) {
                this.options = options.options
            }
        },
        data () {
          return {
            jobDetails: {},
            originalJobDetails: {},
            newNote: '',
            options: {},
            isEditable: false,
            submitting: false,
            mdiPencil,
            mdiClose
          }
        },
        methods: {
          toggleIsEditable() {
            this.jobDetails = {...this.originalJobDetails}
            this.isEditable = !this.isEditable
          },
          async updateJobDetails() {

            // TODO: update job_status (stage), and create new note.
            // the easiest is note. just add to the notes table
            // next easiest is job\
            this.submitting = true

            try {
              const userId = await loadUserId()
              if (this.newNote) {
                // eslint-disable-next-line no-unused-vars
                const {data: notesData, error: noteError} = await postNote(
                    {},
                    {...upsertHeader, ...singleObjectHeader},
                    {
                      job_id: this.jobDetails.job_id,
                      user_id: userId,
                      note: this.newNote
                    })
                if (this.jobDetails.notes) {
                  this.jobDetails.notes.push(notesData.note)
                } else {
                  this.$set(this.jobDetails, 'notes', [notesData.note])
                }
                this.newNote = ''
              }
              if (this.jobDetails.stage_id !== this.originalJobDetails.stage_id) {
                // eslint-disable-next-line no-unused-vars
                const {data: newJobStage, error: jobStageError} = await postJobStage(
                    {},
                    {...upsertHeader, ...singleObjectHeader},
                    {
                      job_id: this.jobDetails.job_id,
                      stage_id: this.jobDetails.stage_id,
                      user_id: userId,
                      date_completed: new Date()
                    }
                )
                this.jobDetails.stage_number = this.jobDetails.stage_number + 1
                this.jobDetails.stage_id = newJobStage.stage_id
              }
              const updatedData = Object.fromEntries(
                Object.entries(this.jobDetails)
                .filter(([key]) => ["job_id", "corp_id", "address", "apartment", "borough", "bin_number", "block", "lot", "project_billing_information", "registration_id", "contact_name", "contact_phone_number", "service_id", "job_size", "supervisor_id", "price"].includes(key))
              )
              // eslint-disable-next-line no-unused-vars
              const {data, error} = await updateJob(
                {'job_id': `eq.${this.jobDetails.job_id}`},
                {...upsertHeader, ...singleObjectHeader},
                updatedData
              )
              this.jobDetails = {...this.jobDetails, ...data}
              this.originalJobDetails = {...this.jobDetails, ...data}
              this.submitting = false
              this.isEditable = false
            } catch (e) {
              console.error(e)
            }

          }
        },
        computed: {
          toggleEditability() {
              return this.isEditable ? {} : { "append-icon": "", class: "custom", "readonly": true}
          },
          corps() {
            return this.options.customerCorps ? this.options.customerCorps[this.jobDetails.customer_id] : []
          },
          stages() {
            return this.options.stages ?
                this.options
                    .stages
                    .filter(
                        stage => stage.service_id === this.jobDetails.service_id &&
                            (stage.stage_number === ((this.jobDetails.stage_number || 0) + 1) || stage.stage_number === this.jobDetails.stage_number)
                    )
                : []
          }
        }
    }
</script>

<style>
.custom.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;

}
.custom.v-text-field>.v-input__control>.v-input__slot:after {
    border-style: none;
}

.custom.theme--light.v-select .v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.87);
}
</style>
